import React from 'react';

const LogoIcon = () => (
  <img src="/images/svgs/software-wagon.svg" alt="logo" className="mr-4" />
)

export default LogoIcon
